import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FormattedMessage } from "react-intl";

class ConfirmDialog extends Component {
  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
        <ModalBody>{this.props.message}</ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={this.props.toggle}>
            <FormattedMessage id={this.props.cancelKey || "Cancel"} />
          </Button>
          <Button
            onClick={this.props.onProceed}
            color={this.props.danger ? "danger" : "primary"}
            outline
          >
            <FormattedMessage id={this.props.proceedKey || "Continue"} />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmDialog;
